import Lookup from 'src/componentes/select2';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from 'src/utils/string';
import { MODULOS } from 'src/utils/constants';
import { translateVariableTerm } from '../../utils/termTranslator';

/**
 * Componente para seleção da Variável de Cálculo
 */
const SmartVariableCalculationSelector = ({ 
  // Props para filtragem (sao obrigatrias)
  isItem,
  tipoItem, 
  tipoEntidade,
  isCestaIndicadores,
  modulosPermitidos,
  hasLift,
  hasScore,
  
  // Props do componente (opcionais)
  value, 
  onChange, 
  showLabel = true, 
  clearable = false,
  className = '',
  labelProps = {},
  includeValorOption = false,
  resources,
  intl,
  ...otherProps
}) => {
  
  // opções do lookup de calculo variael
  const getAllVariableCalculationOptions = () => [

    { id: 'Meta', descricao: 'Meta' },
    { id: 'Realizado', descricao: 'Realizado' },
    { id: 'Estimado', descricao: 'Estimado' },       
    { id: 'Desempenho', descricao: 'Desempenho' },
    { id: 'MetaAcumulado', descricao: 'MetaAcumulado' },
    { id: 'RealizadoAcumulado', descricao: 'RealizadoAcumulado' },
    { id: 'EstimadoAcumulado', descricao: 'EstimadoAcumulado' },
    { id: 'DesempenhoAcumulado', descricao: 'DesempenhoAcumulado' },
    { id: 'DesempenhoEstimado', descricao: 'DesempenhoEstimado' },
    { id: 'DesempenhoEstimadoAcumulado', descricao: 'DesempenhoEstimadoAcumulado' },
    { id: 'MetaPeriodoAnterior', descricao: 'MetaPeriodoAnterior' },
    { id: 'RealizadoPeriodoAnterior', descricao: 'RealizadoPeriodoAnterior' },
    { id: 'DesempenhoPeriodoAnterior', descricao: 'DesempenhoPeriodoAnterior' },
    { id: 'MetaAcumuladoPeriodoAnterior', descricao: 'MetaAcumuladoPeriodoAnterior' },
    { id: 'RealizadoAcumuladoPeriodoAnterior', descricao: 'RealizadoAcumuladoPeriodoAnterior' },
    { id: 'DesempenhoAcumuladoPeriodoAnterior', descricao: 'DesempenhoAcumuladoPeriodoAnterior' },
    { id: 'PontosPorFaixaRealizado', descricao: 'PontosPorFaixaRealizado' },
    { id: 'PontosPorFaixaRealizadoAcumulado', descricao: 'PontosPorFaixaRealizadoAcumulado' },
    { id: 'ScoreFuncao', descricao: 'Score' },
    { id: 'ScoreCategoria', descricao: 'ScoreCategoria' },
    { id: 'PontosPorFaixaTransformada', descricao: 'PontosPorFaixaTransformada' },
    { id: 'ScoreHierarquiaArea', descricao: 'ScoreHierarquiaArea' },
    { id: 'ScoreHierarquiaColaborador', descricao: 'ScoreHierarquiaColaborador' },
    { id: 'MetaAnoAnterior', descricao: 'MetaAnoAnterior' },
    { id: 'RealizadoAnoAnterior', descricao: 'RealizadoAnoAnterior' },
    { id: 'MetaAcumuladoAnoAnterior', descricao: 'MetaAcumuladoAnoAnterior' },
    { id: 'RealizadoAcumuladoAnoAnterior', descricao: 'RealizadoAcumuladoAnoAnterior' },
    { id: 'notaMetaIndividual', descricao: 'notaMetaIndividual' },
  ];

  // condições para mostrar as opções do lookup de calculo variael
  const filterVariableCalculationOptions = (options) => {
    return options.filter((opcao) => {
      switch (opcao.id) {
        case 'Meta':
          return (isItem && tipoItem) || tipoEntidade == 2 || tipoEntidade == 3;

        case 'Realizado':
          return (isItem && tipoItem) || tipoEntidade == 2 || tipoEntidade == 3;

        case 'Desempenho':
          return isItem || tipoEntidade == 2 || tipoEntidade == 3;

        case 'RealizadoAcumulado':
          return tipoItem || tipoEntidade == 2 || tipoEntidade == 3;

        case 'DesempenhoAcumulado':
          return tipoItem || tipoEntidade == 2 || tipoEntidade == 3;

        case 'DesempenhoEstimado':
          return isItem;

        case 'MetaAcumulado':
          return isItem;

        case 'DesempenhoEstimadoAcumulado':
          return isItem && tipoItem && tipoItem !== 3;

        case 'MetaPeriodoAnterior':
          return isItem;

        case 'RealizadoPeriodoAnterior':
          return isItem;

        case 'DesempenhoPeriodoAnterior':
          return isItem;

        case 'MetaAcumuladoPeriodoAnterior':
          return isItem;

        case 'RealizadoAcumuladoPeriodoAnterior':
          return isItem;

        case 'DesempenhoAcumuladoPeriodoAnterior':
          return isItem;

        case 'PontosPorFaixaRealizado':
          return (tipoItem === 1 && modulosPermitidos && modulosPermitidos.find(i => i.ativo && i.id === 3)) || !isItem || isCestaIndicadores || tipoEntidade === 4;

        case 'PontosPorFaixaRealizadoAcumulado':
          return (tipoItem === 1 && modulosPermitidos && modulosPermitidos.find(i => i.ativo && i.id === MODULOS.REMUNERACAO_VARIAVEL)) || !isItem || isCestaIndicadores || tipoEntidade === 4;

        case 'ScoreFuncao':
          return tipoEntidade === 2 || isCestaIndicadores || tipoEntidade === 4 || tipoEntidade === 6;

        case 'ScoreCategoria':
          return tipoEntidade === 4;

        case 'PontosPorFaixaTransformada':
          return (tipoEntidade === 2 || isCestaIndicadores) && modulosPermitidos && modulosPermitidos.find(i => i.ativo && i.id === MODULOS.REMUNERACAO_VARIAVEL);

        case 'ScoreHierarquiaArea':
          return (tipoEntidade === 2 || tipoEntidade === 6) && modulosPermitidos && modulosPermitidos.find(i => i.ativo && i.id === MODULOS.REMUNERACAO_VARIAVEL);

        case 'ScoreHierarquiaColaborador':
          return (tipoEntidade === 2 || tipoEntidade === 6) && modulosPermitidos && modulosPermitidos.find(i => i.ativo && i.id === MODULOS.REMUNERACAO_VARIAVEL);

        case 'MetaAnoAnterior':
          return isItem;

        case 'RealizadoAnoAnterior':
          return isItem;

        case 'MetaAcumuladoAnoAnterior':
          return isItem;

        case 'RealizadoAcumuladoAnoAnterior':
          return isItem;

        case 'notaMetaIndividual':
          return (tipoEntidade === 2 || isCestaIndicadores || tipoEntidade === 4 || tipoEntidade === 6) && hasLift && hasScore;

        case 'Valor':
          return true; // Sempre disponível quando includeValorOption=true, ex: modal de funçao condicional

        case 'Estimado':
          return isItem;
        
        case 'EstimadoAcumulado':
          return isItem;

        default:
          return true;
      }
    });
  };
  
  const allOptions = getAllVariableCalculationOptions();
  
  // opção valor se necessário
  const optionsWithValor = includeValorOption 
    ? [...allOptions, { id: 'Valor', descricao: 'Valor' }]
    : allOptions;
  
  // filtra
  const filteredOptions = filterVariableCalculationOptions(optionsWithValor);
  
  // prioriza meta como primeira opçao do lookup
  const metaIdx = filteredOptions.findIndex(o => o.id === 'Meta');
  if (metaIdx > 0) {
    const [meta] = filteredOptions.splice(metaIdx, 1);
    filteredOptions.unshift(meta);
  }
  
  // traduz as descrições
  const processedOptions = filteredOptions.map(option => ({
    ...option,
    descricao: translateVariableTerm(option.descricao, resources, intl)
  }));

  const valueToPass = value && typeof value === 'object' ? value.id : value;
  const selectedOption = processedOptions.find(o => o.id === valueToPass) || null;
  
  // Se n tiver valor mas tem opções, selecionar a primeira
  const finalSelectedOption = selectedOption || (processedOptions.length > 0 ? processedOptions[0] : null);

  return (
    <Lookup
      clearable={clearable}
      labelKey="descricao"
      valueKey="id"
      options={processedOptions}
      className={className}
      selectFirstValue={false}
      model={{
        label: showLabel ? capitalizeFirstLetter(intl.formatMessage({ id: 'variavelDeCalculo', ...labelProps })) : null,
        value: finalSelectedOption,
        requestChange: onChange,
      }}
      {...otherProps}
    />
  );
};

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(SmartVariableCalculationSelector)); 